<div *ngIf="dialogData" data-test-id="modal-message" class="modal-window">
  <form [formGroup]="messageForm">
    <div class="modal-header">
      <h4 class="modal-title" data-test-id="modal-title">
        {{ 'SEND_MESSAGE_TITLE_DIALOG' | translate }}
      </h4>
      <button
        type="button"
        class="unstyled-button"
        aria-label="Close"
        data-test-id="modal-btn-dismiss"
        (click)="onDismiss()"
      >
        <svg-icon src="assets/icons/icon-cross.svg" class="icon-cross"></svg-icon>
      </button>
    </div>
    <div class="modal-body" data-test-id="wrap-dialog-message">
      <ul *ngIf="dialogData.users.length" class="list-unstyled m-0">
        <li *ngFor="let user of dialogStrategy.users; index as i" class="d-inline-block me-2 w-100">
          <div class="d-flex mb-3">
            <img
              [attr.data-test-id]="'modal-author-image-' + i"
              [src]="user.imageUrl"
              width="24"
              height="24"
              class="user-avatar align-self-center me-2"
              default="{{ FALLBACK_IMAGE }}"
              alt="..."
            />
            <div [attr.data-test-id]="'modal-author-name-' + i" class="media-body mb-0 dotted-text">
              {{ user.displayName }}
            </div>
          </div>
        </li>
      </ul>

      <div *ngIf="!dialogData.users.length" class="mb-3">
        <div class="custom-angular2-multiselect">
          <angular2-multiselect
            [data]="suggestedUsers"
            formControlName="shareInput"
            [settings]="searchSettings"
            (onDeSelectAll)="onDeSelectAllUsers()"
            (onOpen)="onOpenDropdown()"
          >
            <c-search>
              <ng-template>
                <input
                  #searchInput
                  type="text"
                  appDebounceKeyboardKeyup
                  (debounceKeyUp)="onSearchKeywordChanged($event)"
                  [debounceTime]="DEBOUNCE_TIME"
                  [placeholder]="'CHAT_DIALOG_SEARCH_BY_USERS_HINT' | translate"
                  style="border: none; width: 100%; height: 100%; outline: none"
                  data-test-id="search-input"
                />
              </ng-template>
            </c-search>
            <c-item>
              <ng-template let-item="item">
                <img
                  class="item-image"
                  [src]="item.image || FALLBACK_IMAGE"
                  default="{{ FALLBACK_IMAGE }}"
                  alt="avatar"
                />
                <label class="form-label item-label">{{ item.itemName }}</label>
              </ng-template>
            </c-item>
          </angular2-multiselect>
        </div>
        <div
          *ngIf="messageForm.touched && !isUsersSelected"
          class="small text-danger mt-1"
          data-test-id="text-no-users-error"
        >
          {{ 'CHAT_DIALOG_NO_SELECTED_USERS_ERROR' | translate }}
        </div>
      </div>
      <app-message-form-field
        data-test-id="dialog-form"
        [placeholderPhrases]="placeholderPhrases"
        [counterVisibility]="true"
        (sendTextMessage)="submit($event)"
      ></app-message-form-field>
    </div>
  </form>
</div>
